import React from 'react'
import { useMemo } from 'react'

import Grid from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import { findReplyByQuestionId, getReplyValue } from '../_helpers/pdfHelpers'
import { useFormReply } from '../_load/FormReplyLoader'
import Separator from '../../../../components/helpers/Separator'

const Footer = ({ templateId }) => {
  const { replies } = useFormReply()

  const getContractor = () => {
    if (templateId >= 9 && templateId <= 16) {
      return getReplyValue(findReplyByQuestionId(replies, 271))
    }
    if (templateId === 8) {
      return getReplyValue(findReplyByQuestionId(replies, 138))
    }

    return getReplyValue(findReplyByQuestionId(replies, 118))
  }

  const contractor = getContractor()

  const contractorImage = useMemo(() => {
    switch (contractor.name) {
      case 'HRH IDS':
        return '/pdfs/vci/v3/footer-ilha-do-sol.jpg'
      case 'HRH JERI':
        return '/pdfs/vci/v3/footer-jeri.jpg'
      case 'VENTURE FORTALEZA':
        return '/pdfs/vci/v3/footer-fortaleza.jpg'
      default:
        return '/pdfs/vci/v3/footer-sao-paulo.jpg'
    }
  }, [contractor.name])

  return (
    <>
      <Separator weight={5} />
      <Grid justify="center" align="center">
        {!!contractorImage && <Image src={contractorImage} ignoreFixedSize />}
      </Grid>
    </>
  )
}

export default Footer
